import React from 'react';
import PropTypes from 'prop-types';
import { Query, useQuery } from 'react-apollo';
import { GET_CB_RADIO_TEXT, GET_CB_RADIO_STATE } from '../queries/device.queries';
import { Fragment } from 'react';
import './styles/sign.scss';

const CitizensBandRadioView = ({
  ID, textID
}) => {

  const cbCodeQuery = useQuery(GET_CB_RADIO_STATE, {variables:{id: ID, name: textID}})

  if(!textID || textID === undefined || textID === "N/A") {
    return (
      <Fragment>
        <div className="cb-radio-image"></div>
        <div className="ticker-wrap"></div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Query query={GET_CB_RADIO_TEXT} variables={{id: ID, name: textID}} fetchPolicy="cache-first">
        {({ data, error, loading }) => {

            if(error !== undefined) {
              console.log("CitizensBandRadioView", error);
              return null;
            }

            if(data !== undefined && data.citizensBandRadioText !== null) {
              let className = data.citizensBandRadioText === "" ? "cb-radio-image off" : "cb-radio-image on";
              return (
                <div>
                  <div className={className}></div>
                  {
                    cbCodeQuery.data && 
                    <div className='cb-radio-image' style={{ display:'flex', backgroundColor:'white' ,justifyContent:'center', color:'black', fontSize:12, fontWeight:'bold', height:14}}>
                      {cbCodeQuery.data.citizensBandRadioState}
                    </div>
                  }
                  <div style={{backgroundColor:'white'}}>
                    <div className="ticker-wrap">
                      
                      <div className="ticker">
                        <div className="ticker__item">{data.citizensBandRadioText}</div>
                      </div>    
                    </div>
                  </div>
                </div>
              );
            }
            return null;
        }}
      </Query>
    </Fragment>
  );
};

CitizensBandRadioView.propTypes = {
  ID: PropTypes.string.isRequired,
  textID: PropTypes.string.isRequired
};

export default CitizensBandRadioView;